export const Week = {
  Sun: '日',
  Mon: '月',
  Tue: '火',
  Wed: '水',
  Thu: '木',
  Fri: '金',
  Sat: '土',
  Hol: '祝',
} as const
export type WeekKey = (typeof Week)[keyof typeof Week]

export const WeekIndex = {
  Mon: 0,
  Tue: 1,
  Wed: 2,
  Thu: 3,
  Fri: 4,
  Sat: 5,
  Sun: 6,
  Hol: 7,
}
export type WeekIndexKey = (typeof WeekIndex)[keyof typeof WeekIndex]

export function dayOfWeeks(weekOnly: boolean = false): WeekKey[] {
  if (weekOnly) {
    return [
      Week.Mon,
      Week.Tue,
      Week.Wed,
      Week.Thu,
      Week.Fri,
      Week.Sat,
      Week.Sun,
    ]
  }

  return [
    Week.Mon,
    Week.Tue,
    Week.Wed,
    Week.Thu,
    Week.Fri,
    Week.Sat,
    Week.Sun,
    Week.Hol,
  ]
}

export function weekAsBit(weeks: boolean[]): number {
  return weeks.reduce((acc, cur, i) => (cur ? acc | (1 << i) : acc), 0)
}

export function bitAsWeek(bit: number): boolean[] {
  return dayOfWeeks().map((_, i) => (bit & (1 << i)) !== 0)
}
